import PropTypes from 'prop-types';
import React from 'react';
import {List, ListItem, ListItemText, ListItemIcon, Tooltip} from '@material-ui/core';
import {CloudDownload} from '@material-ui/icons';
import {Link} from 'react-router';

function DocumentList(props) {
  const dateOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const {documents} = props;

  return (
    <List>
      {documents.map((doc) => (
        <Tooltip key={doc.url} title={`View ${doc.filename}`}>
          <ListItem button component={Link} href={doc.url} target="_blank">
            <ListItemText
              primary={doc.filename}
              secondary={new Date(doc.lastModified).toLocaleDateString('en-AU', dateOptions)}
            />
            <ListItemIcon>
              <CloudDownload />
            </ListItemIcon>
          </ListItem>
        </Tooltip>
      ))}
    </List>
  );
}

DocumentList.propTypes = {
  documents: PropTypes.array.isRequired,
};

export default DocumentList;
